module.exports = __webpack_public_path__ + "img/POP-00015-1.e27805c9.png";